import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const button = css`
  inset-block-end: ${spacing(-0.5)};
  position: sticky;
`
export const submitButton = css`
  padding: ${spacing(1)}; // 8px
  transition: filter 0.2s ease-in-out;
`

export const form = css`
  flex: 1;
  position: relative;
  z-index: 6;
`

export const map = css`
  background-color: ${cssTheme.default.day.backgroundMinor};
  inset-block: 0;
  inset-inline: 0;
  position: fixed;
  cursor: pointer;
  z-index: 5;
`
